export default __webpack_public_path__ + "static/media/society_redevelopment.06b4ca58.pdf";